import { Component, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-view-report-dialog',
  standalone: true,
  imports: [CommonModule, SafeUrlPipe, SpinnerComponent],
  templateUrl: './view-report-dialog.component.html',
})
export class ViewReportDialogComponent {
  @Input() show = false;
  @Input() showHeader: boolean = false;
  @Input() pdfUrl: string | null = null;
  @Input() fileNumber: string | null = null;
  @Output() close = new EventEmitter<void>();
  isLoading: boolean = true;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  onClose() {
    this.close.emit();
  }

  downloadReport() {
    if (this.pdfUrl) {
      const link = document.createElement('a');
      link.href = this.pdfUrl;
      link.download = this.fileNumber ? `IdentityVerification-${this.fileNumber}.pdf` : 'IdentityVerification-report.pdf';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  onPdfLoad() {
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    });
  }
} 